export enum EGENDER {
    MAN = 'Man',
    WOMAN = 'Woman',
    MALE = 'male',
    FEMALE = 'female',
}
export enum ESubjectQuestion {
    BODY_SHAPE_SUBJECT_QUESTION = 'TAFFI_BODY_SHAPES',
    BODY_TYPE_SUBJECT_QUESTION = 'TAFFI_BODY_TYPES',
    PERSONAS_MALE_SUBJECT = 'PERSONAS_MALE',
    PERSONAS_FEMALE_SUBJECT = 'PERSONAS_FEMALE',
    MY_PHOTOS_SUBJECT_QUESTION = 'TAFFI_MY_PHOTOS',
    MY_BIRTHDAY_SUBJECT = 'TAFFI_BIRTHDAY',
    SKIN_TONE = 'TAFFI_SKINTONE',
    PATTERN_MALE_SUBJECT = 'PATTERN_MALE',
    PATTERN_FEMALE_SUBJECT = 'PATTERN_FEMALE',
    FASHION_RESTRICTION_MALE_SUBJECT = 'FASHION_RESTRICTION_MALE',
    FASHION_RESTRICTION_FEMALE_SUBJECT = 'FASHION_RESTRICTION_FEMALE',
    SKIN_UNDERTONE = 'TAFFI_SKIN_UNDERTONE',
    HAIR_COLOR = 'TAFFI_HAIR_COLOR',
    EYE_COLOR = 'TAFFI_EYE_COLOR',
    SHOW_OFF = 'TAFFI_SHOW_OFF',
    GENDER = 'GENDER',
    SIZES = 'TAFFI_SIZES_QUIZ',
    HIJAB = 'TAFFI_QUIZ_HIJAB_FEMALE',
    COVER = 'TAFFI_COVER',
    SOCIAL_MEDIA = 'TAFFI_SOCIAL_MEDIAS',

    // Session question subject
    SESSION_PURPOSE_SUBJECT = 'TAFFI_SESSION_PURPOSE',
    SESSION_LOCATION_SUBJECT = 'TAFFI_SESSION_LOCATION',
    SESSION_SEASON_SUBJECT = 'TAFFI_SESSION_SEASON',
    SESSION_ENVIRONMENT_SUBJECT = 'TAFFI_SESSION_ENVIRONMENT',
    SESSION_THEME_SUBJECT = 'TAFFI_SESSION_THEME',
    SESSION_STYLE_PREFERENCES_SUBJECT = 'TAFFI_SESSION_STYLE_PREFERENCES',
    SESSION_FOCUS_SUBJECT = 'TAFFI_SESSION_FOCUS',
    SESSION_EXPECTED_SUBJECT = 'TAFFI_SESSION_EXPECTED',
    SESSION_WARDROBE_SUBJECT = 'TAFFI_SESSION_WARDROBE',
    SESSION_MIX_AND_MATCH_SUBJECT = 'TAFFI_SESSION_MIX_AND_MATCH',
}

export enum ETemplateTypes {
    IMAGE_SINGLE_SELECT = 'image_single_select',
    NORMAL = 'normal',
    STYLE_QUIZ = 'style_quiz',
    GRID = 'grid',
    LIST = 'list',
}
export enum EQuizId {
    BODY_SHAPE = 'body_shape_quiz',
    BODY_TYPE = 'body_type_quiz',
    STYLE_QUIZ_MAN = 'customer_men_style_quiz',
    STYLE_QUIZ_WOMAN = 'customer_women_style_quiz',
    FASHION_RESTRICTION_QUIZ_MAN = 'fashion_restriction_man_quiz',
    FASHION_RESTRICTION_QUIZ_WOMAN = 'fashion_restriction_woman_quiz',
    PERSONAS_FEMALE_QUIZ = 'personas_female_quiz',
    PERSONAS_MALE_QUIZ = 'personas_male_quiz',
    PATTERN_QUIZ_WOMAN = 'pattern_woman_quiz',
    PATTERN_QUIZ_MAN = 'pattern_man_quiz',
    GENDER_QUIZ = 'gender_quiz',
    MY_PHOTOS_QUIZ = 'my_photo_quiz',
    MY_BIRTHDAY_QUIZ = 'birthday_quiz',
    SKIN_TONE = 'skintone_quiz',
    COLOR_QUIZ = 'color_quiz',
    SKIN_UNDERTONE = 'skin_undertone_quiz',
    BUDGET_WOMAN_QUIZ = 'budget_woman_quiz',
    BUDGET_MAN_QUIZ = 'budget_man_quiz',
    HAIR_COLOR = 'hair_color_quiz',
    SIZES_MALE = 'sizes_male_quiz',
    SIZE_FEMALE = 'sizes_female_quiz',
    EYE_COLOR = 'eye_color_quiz',
    SHOW_OFF = 'show_off_quiz',
    COVER = 'cover_quiz',
    HIJAB = 'hijab_female_quiz',
    MEASUREMENTS_QUIZ_FEMALE = 'measurements_female_quiz',
    MEASUREMENTS_QUIZ_MALE = 'measurements_male_quiz',
    SOCIAL_MEDIA_QUIZ = 'social_media_quiz',

    // Session quiz
    SESSION_LOCATION_QUIZ = 'session_location_quiz',
    SESSION_SEASON_QUIZ = 'session_season_quiz',
    SESSION_ENVIRONMENT_QUIZ = 'session_environment_quiz',
    SESSION_THEME = 'session_theme_quiz',
    SESSION_STYLE_PREFERENCES_QUIZ = 'session_style_preferences_quiz',
    SESSION_FOCUSED_ITEMS_QUIZ = 'session_focused_items_quiz',
    SESSION_EXPECTED_ITEMS_QUIZ = 'session_expected_items_quiz',
    SESSION_WARDROBE_QUIZ = 'session_wardrobe_quiz',
    SESSION_MIX_AND_MATCH_QUIZ = 'session_mix_and_match_quiz',
}
export enum EQuestionId {
    BODY_SHAPE = 'body_shape_question',
    BODY_TYPE = 'body_type_question',
    PERSONAS_MALE_ID = 'personas_male_question',
    PERSONAS_FEMALE_ID = 'personas_female_question',
    MY_BIRTHDAY = 'birthday_question',
    SKIN_TONE = 'skintone_question',
    SKIN_UNDERTONE = 'skin_undertone_question',
    HAIR_COLOR = 'hair_color_question',
    EYE_COLOR = 'eye_color_question',
    GENDER = 'gender_question',
    SIZES = 'question_sizes',
    COLOR = 'color_question',
    PATTERN = 'pattern_question',
    FASHION_RESTRICTION = 'fashion_restriction_quiz_question',
    SHOW_OFF = 'show_off_question',
    HIJAB = 'question_hijab_female',
    MEASUREMENTS = 'measurements',
    COVER = 'cover_question',
    SOCIAL_MEDIA = 'social_media_quiz_question',

    // Session question question ids
    SESSION_LOCATION_QUESTION = 'session_location_question',
    SESSION_SEASON_QUESTION = 'session_season_question',
    SESSION_ENVIRONMENT_QUESTION = 'session_environment_question',
    SESSION_THEME_QUESTION = 'session_theme_question',
    SESSION_STYLE_PREFERENCES_QUESTION = 'session_style_preferences_question',
    SESSION_FOCUS_QUESTION = 'session_focused_items_question',
    SESSION_EXPECTED_QUESTION = 'session_expected_items_question',
    SESSION_WARDROBE_QUESTION = 'session_wardrobe_question',
    SESSION_MIX_AND_MATCH_QUESTION = 'session_mix_and_match_question',
}

export const quizContextType = 'quiz';

export const quizzesWithoutSkip = [EQuizId.MY_BIRTHDAY_QUIZ, EQuizId.PERSONAS_FEMALE_QUIZ, EQuizId.PERSONAS_MALE_QUIZ];
